/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
const proxyUrl = {
    pro: 'https://sg-proxy.upliveapp.com/index/index',
    dev: 'http://awsbj-proxy.xingyunzhi.cn/index/index',
    stage: 'https://sg-stage-proxy.upliveapp.com/index'
};

class PbAajx {

    constructor() {
        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    do(cfg, data, success = () => {}, timeout = () => {}, fail = () => {}) {
        let prefix = proxyUrl[this.env()];

        if (!cfg.header) {
            cfg.header = {};
        }


        let UserAgent = UP.Global.getDefaultUA();
    
        if (cfg.header.UserAgent && cfg.header.UserAgent.indexOf('feature/9999') > -1) {
            UserAgent += ' feature/9999';
        }
        
        cfg.header.UserAgent = UserAgent;
        

        let _url = prefix + '?' + $.param(cfg);
        let timer, xhr;
        
        timer = setTimeout(function() {
            timeout();
        }, 20 * 1000);

        try {
            xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open("POST", _url, true);
            xhr.responseType = "arraybuffer";

            try {
                xhr.send(data.toArrayBuffer());
            } catch (e) {
                xhr.send();
            }
        } catch (e) {
            alert('please upgrade your brower, such as chrome!');
        }

        xhr.onreadystatechange = (data)=>{

            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    clearTimeout(timer);
                    if (!this.canceled) {
                        success(xhr.response);
                    }
                    
                } else {
                    if (typeof fail == 'function') {
                        fail();
                    }
                }
            }
        }


    }

    query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    env() {
        return this.query('env') || 'pro';
    }

    serializeURI(obj) {
        var result = [];
        if (typeof obj != 'object') {
            obj = {};
        }
        for (var i in obj) {
            result.push(i + '=' + encodeURIComponent(obj[i]));
        }

        return result.join('&')
    }

    cancel() {
        this.canceled = 1;
    }
}

export default PbAajx;



// WEBPACK FOOTER //
// ./js/lib/pbajax/index.js